import { G_GRAPH__DRAG_AND_DROP__image_external } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__image_external';
import { G_GRAPH__DRAG_AND_DROP__image_internal } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__image_internal';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_BUTTON__image_asset_select_from_existing } from '../_buttons/G_BUTTON__image_asset_select_from_existing';
import { G_BUTTON__image_asset_upload } from '../_buttons/G_BUTTON__image_asset_upload';
import { G_UI_FIELD__image_asset_empty_base } from './G_UI_FIELD__image_asset_empty_base';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_UI_FIELD__image_asset_empty_image({ field }: PROPS) {
  return (
    <G_UI_FIELD__image_asset_empty_base>
      <>
        <G_BUTTON__image_asset_upload {...{ field }} />
        <G_BUTTON__image_asset_select_from_existing {...{ field }} />
        {/* todo: uncomment */}
        {/* <G_BUTTON__image_asset_create_with_generation field_consumer={field} generation_tool={GENERATION_TOOL__sd1__img2img()} /> */}

        <G_GRAPH__DRAG_AND_DROP__image_external {...{ field }} />
        <G_GRAPH__DRAG_AND_DROP__image_internal {...{ field }} />
      </>
    </G_UI_FIELD__image_asset_empty_base>
  );
}
